import { mogamboRequestV3 } from '@src/api/utils';
import { BASE_URL } from '@src/const';
import { getQueryParams } from './utils';

const TEMP_URL = `${BASE_URL.replace('mogambo_api/', '')}integration/zoho`;

const constructBusinessIdQueryParam = () => {
  const iva = JSON.parse(localStorage.getItem('ww_iva'));
  return `business_id=${iva?.business?.[0]?.id || ''}`;
};

export const fetchAuthoriseURL = () => {
  const url = `${TEMP_URL}/redirect_url/?${constructBusinessIdQueryParam()}`;
  const response = mogamboRequestV3(url, 'GET', undefined, '');
  return Promise.resolve(response);
};

export const fetchTokens = () => {
  let queryParams = `?${constructBusinessIdQueryParam()}&`;
  const params = getQueryParams();
  const { origin, pathname } = window.location;
  const redirectBaseUrl = `${origin}${pathname}`;
  if (params?.code) {
    queryParams += `code=${params.code}&redirect_url=${redirectBaseUrl}?zohoAuthorized=true`;
  }
  const url = `${TEMP_URL}/receive_code/${queryParams}`;
  const response = mogamboRequestV3(url, 'GET');
  return Promise.resolve(response);
};

export const fetchPortals = () => {
  const url = `${TEMP_URL}/portals/?${constructBusinessIdQueryParam()}`;
  const response = mogamboRequestV3(url, 'GET', undefined, '');
  return Promise.resolve(response);
};

export const fetchBrands = (screenName) => {
  let queryParams = constructBusinessIdQueryParam();
  if (screenName) {
    queryParams += `&screen_name=${screenName}`;
  }
  const url = `${TEMP_URL}/apps_list/?${queryParams}`;
  const response = mogamboRequestV3(url, 'GET', undefined, '');
  return Promise.resolve(response);
};

export const fetchDepartments = ({ screenName, appId }) => {
  let queryParams = constructBusinessIdQueryParam();
  if (screenName) {
    queryParams += `&screen_name=${screenName}&`;
  }
  if (appId) {
    queryParams += `app_id=${appId}`;
  }
  const url = `${TEMP_URL}/apps_details/?${queryParams}`;
  const response = mogamboRequestV3(url, 'GET', undefined, '');
  return Promise.resolve(response);
};

export const createBot = (data, screenName) => {
  let queryParams = constructBusinessIdQueryParam();
  if (screenName) {
    queryParams += `&screen_name=${screenName}`;
  }
  const url = `${TEMP_URL}/create_zobot/?${queryParams}`;
  const response = mogamboRequestV3(url, 'POST', data, '');
  return Promise.resolve(response);
};

export const updateBot = (data) => {
  const queryParams = constructBusinessIdQueryParam();
  const url = `${TEMP_URL}/update_bot/?${queryParams}`;
  const response = mogamboRequestV3(url, 'POST', data, '');
  return Promise.resolve(response);
};
